export default {"src":"/login-app/[GIT_HASH]/_next/static/media/chart_pie.d2eb9c27.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};